<ng-container *ngIf="(state | async).investments.length; else noInvestments">
  <div
    class="table-container uk-margin"
    [ngClass]="{
      'user-height': (state | async).investments.length && showInvestmentCompanyField,
      'table-height-investment-company': (state | async).investments.length && !showInvestmentCompanyField
    }">
    <table class="uk-table uk-table-divider uk-table-hover uk-table-small uk-table-stripped uk-table-justify uk-table-middle">
      <thead>
        <tr>
          <th class="uk-text-nowrap" i18n="@@pitch">pitch</th>

          <th class="uk-text-nowrap" i18n="@@investmentDate">investment date</th>

          <th class="uk-text-nowrap" i18n="@@amount">amount</th>

          <th *ngIf="showInvestmentCompanyField" class="uk-text-nowrap" i18n="@@InvCompanies">inv. company</th>

          <th class="uk-text-nowrap">vps</th>

          <th class="uk-text-nowrap" i18n="@@status">status</th>

          <th class="uk-text-nowrap" i18n="@@accountNo">account no.</th>

          <th class="uk-text-nowrap" i18n="@@payment">payment</th>

          <th class="uk-table-shrink uk-text-right" i18n="@@agreement">agreement</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let investment of (state | async).investments">
          <td>
            <a [routerLink]="['/pitches', investment.pitch_id]">{{ investment.pitch_name }}</a>
          </td>

          <td>{{ investment.created_date | date: 'dd.MM.yy' }}</td>

          <td class="uk-text-nowrap">{{ investment.amount | thousandsNOK }}</td>

          <td *ngIf="showInvestmentCompanyField">
            <ng-container *ngIf="investment.investment_company; else noInvCompany">
              <a [routerLink]="['/investment-companies', investment.investment_company.id]">
                {{ investment.investment_company.name }}
              </a>
            </ng-container>
            <ng-template #noInvCompany>
              <span uk-icon="minus"></span>
            </ng-template>
          </td>

          <td>
            <ng-container *ngIf="investment.vps; else noInvestment">
              {{ investment.vps }}
            </ng-container>

            <ng-template #noInvestment>
              <span uk-icon="minus"></span>
            </ng-template>
          </td>

          <td class="uk-text-nowrap" [ngSwitch]="investment.status">
            <span *ngSwitchCase="investmentStatus.Accepted" i18n="@@Accepted"> Accepted </span>

            <span *ngSwitchCase="investmentStatus.Pending" i18n="@@Pending"> Pending </span>

            <span *ngSwitchCase="investmentStatus.Rejected" i18n="@@Rejected"> Rejected </span>

            <span *ngSwitchCase="investmentStatus.Unsigned" i18n="@@Unsigned"> Unsigned </span>
            <span *ngSwitchCase="investmentStatus.Draft" i18n="@@Draft"> Draft </span>
          </td>

          <td>
            <ng-container *ngIf="investment.account_number; else noAccountNumber">
              {{ investment.account_number }}
            </ng-container>

            <ng-template #noAccountNumber>
              <span uk-icon="minus"></span>
            </ng-template>
          </td>

          <td class="uk-text-nowrap" [ngSwitch]="investment.payment_option">
            <span *ngSwitchCase="paymentOptions.PaymentSlip" i18n="@@PaymentSlip"> Payment slip </span>

            <span *ngSwitchCase="paymentOptions.DirectWithdrawal" i18n="@@DirectWithdrawal"> Direct withdrawal </span>

            <span *ngSwitchCase="paymentOptions.Unspecified" i18n="@@Unspecified"> Unspecified </span>
          </td>

          <td class="uk-text-center">
            <ng-container *ngIf="investment.agreement_url; else noDownload">
              <app-download-file [url]="investment.agreement_url"></app-download-file>
            </ng-container>

            <ng-template #noDownload>
              <span uk-icon="minus"></span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #noInvestments>
  <div *ngIf="(state | async).alreadyRequested.includes(switchViews.Investments)" class="uk-text-center" i18n="@@UserNotInvested">
    User has not invested.
  </div>
</ng-template>
